var exports = {
  "iY": "AccountDeleteModal.module__infoSection___djU0UG",
  "et": "AccountDeleteModal.module__infoBox___djU0UG",
  "I$": "AccountDeleteModal.module__infoBoxTitle___djU0UG",
  "Dj": "AccountDeleteModal.module__infoList___djU0UG",
  "ed": "AccountDeleteModal.module__disclaimer___djU0UG",
};

module.exports = exports;
